<section class="app-filter-chips-bar" [class.is-dense]="dense()">
	<div class="app-filter-chips-bar__header" [class.is-empty]="!title() && !helper()">
		<div class="app-filter-chips-bar__titles">
			@if (title()) {
				<div class="app-filter-chips-bar__title">{{ title() }}</div>
			}
			@if (helper()) {
				<div class="app-filter-chips-bar__helper">{{ helper() }}</div>
			}
		</div>
		<div class="app-filter-chips-bar__actions">
			<ng-content select="[appFilterChipsActions]"></ng-content>
		</div>
	</div>
	<div class="app-filter-chips-bar__chips">
		<ng-content></ng-content>
	</div>
</section>
